import { ICalendarSet, ITenantHolidayResponse } from "@miplatform/types";
import { HolidayFormData } from "./schemas/ConfigHoliday.schema";

export interface IHolidayFormData extends HolidayFormData {
  id?: string;
  modifiedOn?: string;
  orderCalendarSets: ICalendarSet[];
  workOrderCalendarSets: ICalendarSet[];
}

export const defaultHolidayData: IHolidayFormData = {
  name: "",
  startDate: "",
  endDate: "",
  orderCalendarSetIds: [],
  workOrderCalendarSetIds: [],
  orderCalendarSets: [],
  workOrderCalendarSets: [],
};

export const mapHolidayResponseToFormData = (
  holiday: ITenantHolidayResponse,
  orderCalendarSets: ICalendarSet[] = [],
  workOrderCalendarSets: ICalendarSet[] = []
): IHolidayFormData => ({
  ...defaultHolidayData,
  name: holiday.name,
  startDate: holiday.startDate,
  endDate: holiday.endDate,
  id: holiday.id,
  modifiedOn: holiday.modifiedOn,
  orderCalendarSets,
  orderCalendarSetIds: orderCalendarSets.map((cs) => cs.id),
  workOrderCalendarSets,
  workOrderCalendarSetIds: workOrderCalendarSets.map((cs) => cs.id),
});
